export default function ReviewSubmitStep({ formData, onSubmit }) {
  return (
    <div>
      <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 mb-6">
        <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">
          REQUEST SUMMARY
        </p>
        <h3 className="text-xl font-extrabold text-gray-900 mb-5">
          {formData.projectName || "Untitled Project"}
        </h3>

        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <p className="text-sm text-gray-500 mb-1">Category</p>
            <p className="font-semibold text-gray-900">{formData.category || "—"}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">Process</p>
            <p className="font-semibold text-gray-900">{formData.process || "—"}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">Centre</p>
            <p className="font-semibold text-gray-900">
              {formData.centre ? `APIC ${formData.centre}` : "—"}
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">Files</p>
            <p className="font-semibold text-gray-900">
              {formData.files.length} uploaded
            </p>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={onSubmit}
        className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold py-3.5 rounded-xl hover:opacity-90 transition"
      >
        Submit Prototype Request →
      </button>
    </div>
  );
}